var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-core__header",
      class: { "_drawer-open": _vm.drawerOpen },
    },
    [
      _c("div", { staticClass: "el-core__header__left eu-pl_4" }, [
        _c("div", { staticClass: "emd-logo-custom" }, [
          _c("div", [_c("logo-stone-rebrand")], 1),
        ]),
      ]),
      _c("div", { staticClass: "el-core__header__right" }, [
        _c("div", { staticClass: "emd-drawer _right" }, [
          _c(
            "div",
            {
              staticClass: "emd-drawer__trigger",
              class: { _open: _vm.drawerOpen },
            },
            [
              _c(
                "button",
                {
                  staticClass: "emd-action-button",
                  on: { click: _vm.toggleDrawerMenu },
                },
                [
                  _c("i", {
                    staticClass: "uil uil-ellipsis-v emd-action-button__icon",
                  }),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "emd-drawer__content",
              class: { _open: _vm.drawerOpen },
            },
            [
              _c("emd-user-menu", {
                attrs: { isOpen: _vm.userMenuState },
                on: { userMenuClicked: _vm.toggleUserMenu },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }